import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '../../librerias/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SeleccionPeriodoTitulacionComponent } from './seleccion-periodo-titulacion.component';
import { CompoSeleccionPeriodoTitulacionComponent } from './compo-seleccion-periodo-titulacion/compo-seleccion-periodo-titulacion.component';


@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [SeleccionPeriodoTitulacionComponent, CompoSeleccionPeriodoTitulacionComponent],
  exports: [SeleccionPeriodoTitulacionComponent,CompoSeleccionPeriodoTitulacionComponent]
})
export class SeleccionPeriodoTitulacionModule { }
